import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import TableOfViewRegisters from "./components/TableOfViewRegisters";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Request_Get_Registers_Fuzzy_Search } from "../api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_Registers_With_Options } from "../../../api/Get_Registers_With_Options";

function ViewRegisters() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([]);
  //The below is the useEffect to fetch data from the backend
  // useEffect(() => {
  //   Get_limited_From_MongoDB("Registers_2025", "All", 50, setRegisters);
  // }, []);
  useEffect(() => {
    Get_Registers_With_Options(
      "Registers_2025",
      "All",
      { ProgrammeTitle: "Summer" },
      20,
      {
        customProject: {
          //BasicInfo: 1,
          // MetaData: 1,
          //OrderInfo: 1,
          // _id: 1,
          // Contacts: 1,
        },
      },
      setRegisters,
      logout
    );
  }, []);

  //-----------------------------Flatten Data For Export--------------------------------------------

  let FlattenedData = Registers.map((OneAttendee) => {
    return deepFlattenToObject(OneAttendee);
  });

  function handleLoadAll(e) {
    e.preventDefault();

    Get_All_From_MongoDB("Registers_2025", "All", setRegisters, logout);
    alert(
      "WARNING ! You have just loaded all ARCHIVED records. If you do not need archived records, please use the other load all button. Please ensure, before taking any action, you consider if you need to filter out these people if you plan to export them or email them. Use the column called 'Metadata.Archive'"
    );
  }

  function handleLoadAllLive(e) {
    e.preventDefault();
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {},
      10000,
      setRegisters,
      logout
    );
  }

  function handleLoadAllAttendingQuick(e) {
    Get_Registers_With_Options(
      "Registers_2025",
      "All",
      {},
      10000,
      {
        customProject: {
          BasicInfo: 1,
          MetaData: 1,
          OrderInfo: 1,
          _id: 1,
          Contacts: 1,
        },
      },
      setRegisters,
      logout
    );
  }

  //Creates a variable called RegistersFiltered that filters the Registers based on the FilterEverything state. This only returns true if any of the fields in the Register, and any nested fields, includes the each word FilterEverything state as seperated by spaces.
  const [FilterEverything, setFilterEverything] = useState("");
  const handleFilterEverything = (e) => {
    setFilterEverything(e.target.value);
  };
  const RegistersFiltered = Registers.filter((Register) => {
    return FilterEverything.split(" ").every((word) => {
      return Object.values(Register).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  // const RegistersFiltered = Registers.filter((Register) => {
  //     return Object.keys(Register).some((key) => {
  //       if (typeof Register[key] === "object") {
  //         return Object.keys(Register[key]).some((nestedKey) => {
  //           return Register[key][nestedKey]
  //             .toString()
  //             .toLowerCase()
  //             .includes(FilterEverything.toLowerCase());
  //         });
  //       }
  //       return Register[key]
  //         .toString()
  //         .toLowerCase()
  //         .includes(FilterEverything.toLowerCase());
  //     });
  //   });

  // -----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        {/* <DisplayGoToAddRegister />  */}
        <SearchSetRegisters setRegisters={setRegisters} />
        <div
          style={{
            flex: "0 1 auto",
            display: "flex",
            flexDirection: "row", // Add this line
            flexWrap: "wrap",
            justifyContent: "flex-end",
            width: "70%",
          }}
        >
          <TextField
            id="FilterEverything"
            label="Filter Everything"
            variant="outlined"
            value={FilterEverything}
            onChange={handleFilterEverything}
            fullWidth
            sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
          />

          <DisplayExport excelData={FlattenedData} fileName="Registers_Data" />
          {/* 
          <Box
            component="main"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: "100px",
              maxHeight: "100px",
              Height: "100px",
              flexGrow: 1,
              p: 1,
            }}
          >
            <button onClick={(e) => handleLoadAllAttendingQuick(e)}>
              Quick Load Attending
            </button>
          </Box>
           */}
          <Box
            component="main"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: "100px",
              maxHeight: "100px",
              Height: "100px",
              flexGrow: 1,
              p: 1,
            }}
          >
            <button onClick={(e) => handleLoadAllLive(e)}>
              Full Load Attending
            </button>
          </Box>

          <Box
            component="main"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: "100px",
              maxHeight: "100px",
              Height: "100px",
              flexGrow: 1,
              p: 1,
            }}
          >
            <button onClick={(e) => handleLoadAll(e)}>
              Full Load All (+Archived)
            </button>
          </Box>
          <Box
            component="main"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: "100px",
              maxHeight: "100px",
              Height: "100px",
              flexGrow: 1,
              p: 1,
            }}
          >
            <Link
              //to={`/AddAttendee`}
              to={`/Staff/ViewAttendee/AddAttendee`}
              target="_blank"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <button>Add</button>
            </Link>
          </Box>
        </div>
        <TableOfViewRegisters
          style={{ flex: "0 1 auto" }}
          Registers={RegistersFiltered}
        />
      </div>
    </div>
  );
}

export default ViewRegisters;
